<template>
  <span class="badge mfa-badge" :class="[badgeClass, { 'mfa-compact': compact }]" :title="presentation.description"
    :aria-label="presentation.description" tabindex="0" v-b-tooltip.hover.focus>
    <svg v-if="presentation.tone === 'verified'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      <path d="m9 16 2 2 4-4"/>
    </svg>
    <svg v-else-if="!compact || (summary && summary.status !== 'not_recorded')" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z"/><path d="M8 12h8"/>
    </svg>
    <span>{{ displayLabel }}</span>
  </span>
</template>
<script>
import { mfaPresentation } from "@/utils/mfaStatus";
export default {
  props: { summary: { type: Object, default: null }, compact: { type: Boolean, default: false } },
  computed: {
    presentation() { return mfaPresentation(this.summary); },
    displayLabel() {
      if (!this.compact) return this.presentation.label;
      return ({ verified_trusted: 'Login MFA', trusted_device: 'Trusted',
        previously_verified: 'Previously verified', not_recorded: 'Not recorded' })[this.summary && this.summary.status] || 'Unavailable';
    },
    badgeClass() {
      if (this.compact) return this.summary && this.summary.status === 'previously_verified'
        ? 'mfa-tone-previous' : `mfa-tone-${this.presentation.tone}`;
      return this.presentation.tone === 'verified' ? 'badge-success'
        : this.presentation.tone === 'trusted' ? 'mfa-trusted'
        : this.presentation.tone === 'unavailable' ? 'badge-warning' : 'badge-secondary';
    },
  },
};
</script>
<style scoped>
.mfa-badge { display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; }
.mfa-badge.mfa-compact { background: transparent; border: 0; border-radius: 0; padding: 2px 0; margin: 0; font-size: 12px; line-height: 1.4; font-weight: 500; text-transform: none; letter-spacing: normal; box-shadow: none; }
.mfa-badge.mfa-compact:not(.mfa-tone-neutral) { padding: 2px 5px; border-radius: 3px; font-weight: 500; }
.mfa-compact svg { width: 14px; height: 14px; }
.mfa-badge.mfa-compact.mfa-tone-verified { color: #256029; background: #eaf4e7; }
.mfa-badge.mfa-compact.mfa-tone-trusted { color: #244da3; background: #edf2ff; }
.mfa-badge.mfa-compact.mfa-tone-previous { color: #80500a; background: #fff4dd; }
.mfa-badge.mfa-tone-neutral { color: #637080; }
.mfa-badge.mfa-compact.mfa-tone-unavailable { color: #70409a; background: #f4edfa; }
.mfa-badge.mfa-trusted { color: #025f61; background: #eef7f6; border: 1px solid #8ebbb5; }
.mfa-badge svg { flex-shrink: 0; }
.mfa-badge:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
</style>
